import {
  PERMISSION_CREATE_SUCCESS,
  PERMISSION_LIST_SUCCESS,
  PERMISSION_UPDATE_FILTER,
} from 'src/actions/permission.acction';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    name: '',
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
}

const permissionReducer = (state = initState, action) => {
  switch (action.type) {
    case PERMISSION_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }

    case PERMISSION_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }

    case PERMISSION_CREATE_SUCCESS: {
      return {
        ...state,
        list: {
          data: action.data
        }
      }
    }

    default: {
      return state;
    }

  }
}
export default permissionReducer